import { toQueryParam } from "../../../handlers/filter";
import { organizationTypeToServiceType } from "../../../models/organization";
import { ORGANIZATION_FILTER_KEYS } from "../types";
/**
 * @param filters: array of SDK-style organization filters.
 * @return: a proper query string for the supplied filters.
 */
export const toQueryParams = (filters = {}) => {
    const { where = [] } = filters;
    const queryParams = [];
    // Process each filter condition
    where.forEach(({ field, type, value }) => {
        if (!ORGANIZATION_FILTER_KEYS.includes(field) ||
            value === undefined ||
            value === null ||
            ((Array.isArray(value) || typeof value === "string") && !value.length)) {
            return;
        }
        // Special handling for organization type filter
        if (field === "type") {
            const types = Array.isArray(value) ? value : [value];
            // Convert OrganizationType enum to service string representation
            // Backend expects "ADV" not "ADVERTISER" for query parameters
            const transformedTypes = types.map((orgType) => {
                const serviceType = organizationTypeToServiceType(orgType);
                return serviceType === "ADVERTISER" ? "ADV" : serviceType;
            });
            const orgTypes = toQueryParam({ field, type, value: transformedTypes });
            queryParams.push(`orgTypes=${orgTypes}`);
        }
    });
    if (queryParams.length === 0) {
        return "";
    }
    return `?${queryParams.join("&")}`;
};
//# sourceMappingURL=query.js.map